var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconExperts32Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.125 10.5C24.9419 13.0419 23.0562 15 21 15C18.9437 15 17.055 13.0425 16.875 10.5C16.6875 7.85562 18.5231 6 21 6C23.4769 6 25.3125 7.90375 25.125 10.5Z",
    stroke: "#3DE8A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 19C16.9269 19 13.01 21.0231 12.0287 24.9631C11.8987 25.4844 12.2256 26 12.7612 26H29.2394C29.775 26 30.1 25.4844 29.9719 24.9631C28.9906 20.96 25.0737 19 21 19Z",
    stroke: "#3DE8A0",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11.6213C12.3537 13.6513 10.83 15.25 9.18749 15.25C7.54499 15.25 6.01874 13.6519 5.87499 11.6213C5.72561 9.50938 7.20874 8 9.18749 8C11.1662 8 12.6494 9.54813 12.5 11.6213Z",
    stroke: "#3DE8A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.875 19.125C11.7469 18.6081 10.5044 18.4094 9.18749 18.4094C5.93749 18.4094 2.80624 20.025 2.02186 23.1719C1.91874 23.5881 2.17999 24 2.60749 24H9.62499",
    stroke: "#3DE8A0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExperts32Px);
export default __webpack_public_path__ + "static/media/icon-experts-32px.8e9c5750963b212513c28f2cbcdd3c2e.svg";
export { ForwardRef as ReactComponent };